import { Tab, Tabs } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { useIntl } from 'react-intl';

import { DriversProjectUnits } from '../../../../domain/driversProject/DriversProject';
import { TABS, TabTypes, useAnalyticsFilters } from '../hooks/useAnalyticsFilters';

interface AnalyticsTabsProps {
  units?: DriversProjectUnits;
}

export const AnalyticsTabs = ({ units }: AnalyticsTabsProps) => {
  const intl = useIntl();
  const { tab, setTabParam } = useAnalyticsFilters();

  return (
    <Tabs
      value={tab}
      onChange={(event, newValue) => {
        setTabParam(newValue as TabTypes);
      }}
      aria-label="Analytics tabs"
      variant="scrollable"
      scrollButtons={false}
      TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
      sx={{
        width: `100%`,
        alignItems: `center`,
        '& .MuiTabs-indicator': {
          display: `flex`,
          justifyContent: `center`,
          backgroundColor: `transparent`,
        },
        '& .MuiTabs-indicatorSpan': {
          width: `100%`,
          backgroundColor: RoutalPalette.neutral02n,
        },
        '& .MuiTabs-flexContainer': {
          height: `100%`,
          justifyContent: `space-around`,
        },
        '& button': {
          maxWidth: `100%`,
          minHeight: `100%`,
        },
      }}
    >
      {TABS.map((tabName) => {
        let label;
        if (tabName === `distance`) {
          if (units?.distance === `km`) {
            label = intl.formatMessage({ id: `drivers.analytics.tab.distance_traveled.km` });
          }
          if (units?.distance === `mi`) {
            label = intl.formatMessage({ id: `drivers.analytics.tab.distance_traveled.mi` });
          }
        }
        if (tabName === `stops`) {
          label = intl.formatMessage({ id: `drivers.analytics.tab.stops` });
        }
        if (tabName === `emissions`) {
          label = intl.formatMessage({ id: `drivers.analytics.tab.emissions` });
        }

        return (
          <Tab
            key={tabName}
            label={label}
            value={tabName}
            disableRipple
            sx={{
              height: `40px`,
              minWidth: `24px`,
              textTransform: `none`,
              padding: `0px 16px`,
              fontWeight: 400,
              fontSize: `13px`,
              color: RoutalPalette.neutral20,
              '&.Mui-selected': {
                color: RoutalPalette.neutral02n,
                '&. MuiSvgIcon-root': {
                  color: RoutalPalette.neutral02n,
                },
              },
              '&:hover': {
                color: RoutalPalette.neutral20,
              },
              '&.Mui-selected:hover': {
                color: RoutalPalette.neutral02n, // Ensure the color remains the same when both selected and hovered
                cursor: `default`,
              },
            }}
          />
        );
      })}
    </Tabs>
  );
};
